import { render, staticRenderFns } from "./fcsd_sss_yc.vue?vue&type=template&id=2b6d772d&scoped=true"
import script from "./fcsd_sss_yc.vue?vue&type=script&lang=js"
export * from "./fcsd_sss_yc.vue?vue&type=script&lang=js"
import style0 from "./fcsd_sss_yc.vue?vue&type=style&index=0&id=2b6d772d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d772d",
  null
  
)

export default component.exports